import { Typography } from '@recruit-robin/robin-theme/web-components';
import { AlertTriangle, Eye } from '@recruit-robin/robin-theme/web-icons';
import { useContext } from 'react';

import { LocalizationContext } from 'shared/legacy/contexts/LocalizationContext/LocalizationContext';
import { LoadingPage } from '../../LoadingPage/LoadingPage';
import { CopyButton } from '../CopyButton/CopyButton';
import { useStyles } from './JobDescription.styles';
import { useJobDescription } from './useJobDescription';

export const JobDescription = () => {
  const classes = useStyles();
  const { dictionary } = useContext(LocalizationContext);

  const { copySuccessMessage, description, textToCopy, hasInvalidAts, isLoading, indeedJobLink } = useJobDescription();

  if (hasInvalidAts) {
    return (
      <div css={classes.atsDisconnectedContainer}>
        <AlertTriangle size={24} color={(c) => c.tertiary.red[50]} />
        <div css={classes.atsDisconnectedText}>
          <Typography variant={(v) => v.heading[5]} color={(c) => c.neutral.variant[80]}>
            {dictionary.atsNotConnected}
          </Typography>
          <Typography variant={(v) => v.supporting.helper} color={(c) => c.neutral.variant[60]}>
            {dictionary.atsNotConnectedDescription}
          </Typography>
        </div>
      </div>
    );
  }

  if (isLoading) {
    return <LoadingPage message={`${dictionary.loading}...`} />;
  }

  return (
    <div css={classes.previewContainer}>
      <div css={classes.copyButtonContainer}>
        <CopyButton text={textToCopy} successMessage={copySuccessMessage} />
        {indeedJobLink && (
          <a css={classes.viewOnIndeedLink} href={indeedJobLink} target="_blank" rel="noopener noreferrer">
            <Eye size={16} />
            <Typography variant={(v) => v.supporting.label}>{dictionary.viewOnIndeed}</Typography>
          </a>
        )}
      </div>

      <Typography
        variant={(v) => v.body.short}
        color={(c) => c.neutral.variant[70]}
        css={{ whiteSpace: 'pre-wrap', paddingBottom: 50 }}>
        {description || dictionary.noDataAvailable}
      </Typography>
    </div>
  );
};
